<template>
  <ConteudoPageForm
    apiBasePath="/admin/site-postagens"
    entityName="Postagem"
    breadcrumb="Marketing / Postagens"
    listRouteName="postagens"
    iaEndpoint="/admin/site-postagens/gerar-conteudo-ia"
    iaPlaceholder="Ex: 5 dicas para escolher a tinta ideal"
  />
</template>

<script>
import ConteudoPageForm from '../../components/ConteudoPageForm';

export default {
  name: 'PostagemForm',
  components: { ConteudoPageForm },
};
</script>
